"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBySide = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var SideBySide_1 = require("ContentTokens/Models/SideBySide");
var hydrationHelpers_1 = require("../hydrationHelpers");
var getColumns = function (token) {
    var column1 = token.column1, column2 = token.column2;
    if (token.order) {
        return token.order === SideBySide_1.SideBySideOrder.Normal ? [column1, column2] : [column2, column1];
    }
    return [column1, column2];
};
var getPercentageClass = function (percentage) {
    if (percentage === SideBySide_1.SideBySideColumnSize.OneQuarter) {
        return "side-by-side__col--one-quarter";
    }
    if (percentage === SideBySide_1.SideBySideColumnSize.OneHalf) {
        return "side-by-side__col--one-half";
    }
    if (percentage === SideBySide_1.SideBySideColumnSize.ThreeQuarters) {
        return "side-by-side__col--three-quarter";
    }
};
var SideBySide = function (_a) {
    var token = _a.token, attributes = _a.attributes, options = __rest(_a, ["token", "attributes"]);
    var percent = token.percent || SideBySide_1.SideBySideColumnSize.OneHalf;
    var _b = __read(getColumns(token), 2), leftColumn = _b[0], rightColumn = _b[1];
    var width = token.width;
    var leftColumnOptions = {
        sideBySide: {
            withinSideBySide: true,
            columnWidthPercent: percent,
        },
    };
    var rightColumnOptions = {
        sideBySide: {
            withinSideBySide: true,
            columnWidthPercent: 100 - percent,
        },
    };
    var leftPercentageClass = getPercentageClass(percent);
    var rightPercentageClass = getPercentageClass(100 - percent);
    return (react_1.default.createElement("div", __assign({}, attributes, { className: (0, classnames_1.default)(attributes.className, "side-by-side__wrapper") }),
        react_1.default.createElement("div", { className: (0, classnames_1.default)("side-by-side", "side-by-side--".concat(width)) },
            react_1.default.createElement("div", { className: (0, classnames_1.default)("side-by-side__col", "side-by-side__col--left", leftPercentageClass) },
                react_1.default.createElement(hydrationHelpers_1.ContentArea, { className: "side-by-side__col-content" }, options.renderTokens(leftColumn !== null && leftColumn !== void 0 ? leftColumn : [], leftColumnOptions))),
            react_1.default.createElement("div", { className: (0, classnames_1.default)("side-by-side__col", "side-by-side__col--right", rightPercentageClass) },
                react_1.default.createElement(hydrationHelpers_1.ContentArea, { className: "side-by-side__col-content" }, options.renderTokens(rightColumn !== null && rightColumn !== void 0 ? rightColumn : [], rightColumnOptions))))));
};
exports.SideBySide = SideBySide;
